module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "blog-posts-area section-padding"
  }, [_c('div', {
    staticClass: "container xinwennei912"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('div', {
    staticClass: "col-lg-8 post-list blog-post-list"
  }, [_c('div', {
    staticClass: "single-post"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "110px",
      "line-height": "60px",
      "border-bottom": "1px solid #cccccc"
    }
  }, [_c('h2', {
    staticClass: "news_sun_ziti2"
  }, [_vm._v(_vm._s(_vm.newsinfo.title))]), _vm._v(" "), _c('div', {
    staticClass: "bottom-meta"
  }, [_c('div', {
    staticClass: "user-details row align-items-center"
  }, [_c('div', {
    staticClass: "comment-wrap col-lg-6 col-sm-6"
  }, [_c('ul', [_c('li', [_vm._v("• " + _vm._s(_vm.newsinfo.date))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "200px !important",
      "position": "absolute",
      "right": "10%",
      "cursor": "pointer"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666666"
    }
  }, [_vm._v("浏览量：" + _vm._s(_vm.newsinfo.visits))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrap",
    staticStyle: {
      "margin-top": "50px",
      "line-height": "30px"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.newsinfo.content)
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "nav-area py-5"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-between"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 nav-right justify-content-end d-flex"
  }, [_c('div', {
    staticClass: "post-details"
  }, [_c('p', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666666"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": '/blog?id=' + _vm.cid
    }
  }, [_c('span', {
    staticStyle: {
      "background": "#ddd",
      "padding": "5px 20px",
      "color": "#757575"
    }
  }, [_vm._v("返回列表页")])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar mt-5 mt-lg-0 bbxs912 buxianshia"
  }, [_c('div', {
    staticClass: "single-widget recent-posts-widget",
    staticStyle: {
      "border": "0px",
      "background": "#f7f8fc"
    }
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("拿度推荐")]), _vm._v(" "), _c('div', {
    staticClass: "blog-list"
  }, _vm._l((_vm.newslist), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "width": "100%",
        "height": "250px",
        "border-bottom": "1px solid #cccccc",
        "font-size": "14px",
        "margin-bottom": "20px"
      }
    }, [_c('router-link', {
      staticStyle: {
        "color": "#000"
      },
      attrs: {
        "to": '/blogDetails?id=' + item.id + '&cid=' + _vm.cid
      },
      nativeOn: {
        "click": function($event) {
          return _vm.reloadPage.apply(null, arguments)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%",
        "height": "150px"
      },
      attrs: {
        "src": _vm.newurl + item.ico
      }
    })]), _vm._v(" "), _c('p', {
      staticStyle: {
        "line-height": "50px"
      }
    }, [_vm._v(_vm._s(_vm.truncatecontent(item.title)) + " ...")]), _vm._v(" "), _c('p', [_vm._v("• " + _vm._s(item.date))])])], 1)
  }), 0)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "map-area section-padding news_section1 section"
  }, [_c('div', {
    staticClass: "banner-sun"
  }, [_c('p', {
    staticClass: "p1 animate fadeInDown animated news_sun_ziti1",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    }
  }, [_vm._v("新闻中心")]), _vm._v(" "), _c('p', {
    staticClass: "p2 animate zoomIn animated news_sun_ziti2",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "1s",
      "visibility": "visible",
      "color": "#E91E63"
    }
  }, [_vm._v("NEWS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6 nav-left justify-content-start d-flex"
  }, [_c('div', {
    staticClass: "post-details"
  }, [_c('p')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-815c4220"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/BlogDetails.vue
// module id = 114
// module chunks = 0